import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-style-guide';
import { Thumbnail2d, ThumbnailTypes, DefaultThumbnailSize } from 'roblox-thumbnails';
import urlConstants from '../constants/urlConstants';

const { getUserProfileUrl } = urlConstants;

function PrivateServerOwner({ ownerUserId, ownerName }) {
  return (
    <div className='rbx-private-owner'>
      <Link
        title={ownerName}
        url={getUserProfileUrl(ownerUserId)}
        className='avatar avatar-card-fullbody owner-avatar'>
        <Thumbnail2d
          type={ThumbnailTypes.avatarHeadshot}
          size={DefaultThumbnailSize}
          targetId={ownerUserId}
          containerClass='avatar-card-image'
        />
      </Link>
      <Link url={getUserProfileUrl(ownerUserId)} className='text-name text-overflow'>
        {ownerName}
      </Link>
    </div>
  );
}

PrivateServerOwner.propTypes = {
  ownerUserId: PropTypes.number.isRequired,
  ownerName: PropTypes.string.isRequired
};

export default PrivateServerOwner;
